<div class="legal-container">
  <div class="legal-content">
    <h1>Conditions Générales d'Utilisation</h1>
    <p class="last-updated">Dernière mise à jour : {{ currentDate | date: 'dd/MM/yyyy' }}</p>

    <section>
      <h2>1. Objet</h2>
      <p>
        Les présentes conditions générales d'utilisation (CGU) définissent les règles d'accès et
        d'utilisation de notre plateforme de modélisation.
      </p>
    </section>

    <section>
      <h2> 2. Acceptation des conditions</h2>
      <p>
        L'utilisation de la plateforme implique l'acceptation pleine et entière des présentes CGU.
        Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser nos services.
      </p>
    </section>

    <section>
      <h2>3. Inscription et compte utilisateur</h2>
      <p>Pour utiliser nos services, vous devez:</p>
      <ul>
        <li>Créer un compte avec des informations exactes et à jour.</li>
        <li>Maintenir la confidentialité de vos identifiants.</li>
        <li>Être responsable de toutes les activités effectuées via votre compte.</li>
        <li>Nous informer immédiatement de toute utilisation non autorisée.</li>
      </ul>
    </section>

    <section>
      <h2>4. Utilisation des services</h2>
      <p>Vous vous engagez à :</p>
      <ul>
        <li>Utiliser la plateforme conformément à sa destination.</li>
        <li>Ne pas tenter de contourner les mesures de sécurité.</li>
        <li>Ne pas utiliser la plateforme à des fins illégales.</li>
        <li>Respecter les droits de propriété intellectuelle.</li>
      </ul>
    </section>

    <section>
      <h2>5. Propriété intellectuelle</h2>
      <p>
        Tous les éléments de la plateforme (code, design, logos, ect.) sont protégés par les droits
        de propriété intellectuels. Vous conservez la propriété des contenus que vous créez
        (diagrammes, modèles de bases de données, etc.).
      </p>
    </section>

    <section>
      <h2>6. Responsabilité</h2>
      <p>
        Nous nous efforçons de maintenir la plateforme accessible et fonctionnelle, mais nous ne
        pouvons garantir une disponibilité continue. Nous ne sommes pas responsables des dommages
        indirects résultant de l'utilisation de nos services.
      </p>
    </section>

    <section>
      <h2>7. Modification des CGU</h2>
      <p>
        Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications entrent
        en vigueur dès leur publication. Votre utilisation continue de la plateforme constitue
        votre acceptation des CGU modifiées.
      </p>
    </section>

    <section>
      <h2>8. Résiliation</h2>
      <p>
        Vous pouvez supprimer votre compte à tout moment depuis vos paramètres. Nous nous réservons
        le droit de suspendre ou résilier votre accès en cas de violation des présentes CGU.
      </p>
    </section>

    <section>
      <h2>9. Loi applicable</h2>
      <p>
        Les présentes CGU sont régies par le droit français. Tout litige sera soumis aux tribunaux
        compétents.
      </p>
    </section>

    <section>
      <h2>10. Contact</h2>
      <p>
        Pour toute question concernant ces CGU, veuillez nous contacter à :
        <a href="mailto:contact@example.com">jade.jolivet&#64;gmail.com</a>
      </p>
    </section>
  </div>
</div>
